<template>
  <section class="content_auto">
    <el-form :model="formData">
      <el-form-item prop="nationalId">
        <div class="label">{{ $t('国家') }}</div>
        <el-select
          v-model="formData.nationalId"
          :placeholder="$t('请选择国家')"
          filterable
          style="width:100%"
          size="large"
        >
          <el-option
            v-for="item in countryList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="trueName">
        <div class="label">{{ $t('姓名') }}</div>
        <el-input
          v-model.trim="formData.trueName"
          :placeholder="$t('请输入真实姓名')"
          style="width:100%"
          size="large"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="cardType">
        <div class="label">{{ $t('证件类型') }}</div>
        <el-select
          v-model="formData.cardType"
          :placeholder="$t('请选择证件类型')"
          style="width:100%"
          size="large"
        >
          <el-option
            v-for="item in cardTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="cardNo">
        <div class="label">{{ $t('证件号') }}</div>
        <el-input
          v-model.trim="formData.cardNo"
          :placeholder="$t('请输入证件号')"
          style="width:100%"
          size="large"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div class="commit-btn-box">
      <el-button
        :loading="loading"
        :disabled="disabled"
        class="commit-btn"
        @click="commit"
      >
        {{ $t(' 提交') }}
      </el-button>
    </div>
  </section>
</template>
<script>
import { doCommitC1Auth } from '@/api/personal'
import { updateUserInfo } from '@/utils'
import { registerCountryList } from '@/api/sign'

export default {
  name: 'KYC1Auth',
  data() {
    return {
      loading: false,
      formData: {
        nationalId: '',
        trueName: '',
        cardType: '',
        cardNo: ''
      },
      countryList: [],
      cardTypeList: [
        { id: 'SFZ', name: this.$t('身份证') },
        { id: 'HZ', name: this.$t('护照') },
        { id: 'JZ', name: this.$t('驾照') },
        { id: 'QT', name: this.$t('其它') }
      ]
    }
  },
  computed: {
    disabled() {
      return Object.keys(this.formData).some((key) => !this.formData[key])
    }
  },
  mounted() {
    this.getCountryList()
  },
  methods: {
    async getCountryList() {
      this.countryList = await registerCountryList()
    },
    async commit() {
      this.loading = true
      try {
        await doCommitC1Auth(this.formData)
        this.$Message.success(this.$t('操作成功'))
        await updateUserInfo()
        this.$router.replace({ path: '/identity' })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped lang="less">
section {
  .el-form {
    width: 479px;
    margin: 40px auto 0;
    .label {
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.9);
      line-height: 22px;
      margin-bottom: 8px;
    }
  }
  .commit-btn-box {
    margin: 100px 0;
    text-align: center;
    .commit-btn {
      width: 580px;
      height: 60px;
      text-align: center;
      border-radius: 4px 4px 4px 4px;
      font-size: 18px;
      font-weight: 500;
      background: #1c1b1b;
      color: #ffffff;
      cursor: pointer;
      &.el-button.is-disabled,
      &.el-button.is-disabled:focus,
      &.el-button.is-disabled:hover {
        background: #a2a2a2;
        color: #fff;
        cursor: not-allowed;
      }
    }
  }
}
</style>
